import { Product } from '@setvi/shared/interfaces';
import { useAssociatedProducts } from 'componentsV2/product/details/content/subpages/associated-products/useAssociatedProducts';
import { ProductsEmptyState } from 'componentsV2/product/details/content/components';
import { TabContentWrapper } from '../styled';
import {
  MobileProductCardProps,
  MobileProductListCard
} from '../../../list/components';
import { ListLoader } from '../../../list/components/product-card/list/components';

interface MobileAssociatedProductsProps {
  product: Product;
  selectedProducts: Product[];
  productCardProps: Omit<MobileProductCardProps, 'product' | 'checked'>;
}

export const MobileAssociatedProducts = ({
  product,
  selectedProducts,
  productCardProps
}: MobileAssociatedProductsProps) => {
  const { associatedProducts, isLoading } = useAssociatedProducts({ product });

  if (isLoading) return <ListLoader />;

  if (!associatedProducts.length && !isLoading)
    return <ProductsEmptyState title="No options and accessories found" />;

  return (
    <TabContentWrapper>
      {associatedProducts.map(i => {
        const isChecked = selectedProducts.some(j => j._id === i._id);
        return (
          <MobileProductListCard
            product={i}
            {...productCardProps}
            checked={isChecked}
          />
        );
      })}
    </TabContentWrapper>
  );
};
